// https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories

import { InboundEmailInboxInput } from '../../../gql/graphql';

const inboundEmailKeys = {
  all: ['me', 'inboundEmail'] as const,
  lists: () => [...inboundEmailKeys.all, 'lists'] as const,
  inbox: (input?: InboundEmailInboxInput) => {
    if (!input) {
      return [...inboundEmailKeys.lists(), 'inbox'] as const;
    }

    return [...inboundEmailKeys.lists(), 'inbox', input] as const;
  },
  unreadCount: () => [...inboundEmailKeys.lists(), 'unreadCount'] as const,
  unassignedCount: () =>
    [...inboundEmailKeys.lists(), 'unassignedCount'] as const,
  detail: (id: string) => [...inboundEmailKeys.all, 'detail', id] as const,
  addresses: () => [...inboundEmailKeys.all, 'addresses'] as const,
};

export default inboundEmailKeys;
